<template>
  <section class="section-wrapp">
    <Breadcrumbs v-if="breadcrumbsData !== null" v-bind:parameters="breadcrumbsData"></Breadcrumbs>
    <section class="section-graph">
      <div v-if="(stationId !== null) && (tabsConfig !== null)" class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="style graph-tabs-list">
              <ul @click="toggleClass()" v-bind:class="{visible: isActive}">
                <li v-for="tab in tabs" @click="clickTabs(tab.id)" v-bind:class="{active: (tab.id === currentTab)}" v-bind:key="tab.id">{{ tab.title }}</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="row">
          <div v-if="values !== null" class="col-12">
            <div v-for="tab in tabs" v-bind:key="tab.id" v-show="currentTab === tab.id" class="device-graph-table style">
              <div class="device-graph style">
                <highcharts :key="tab.id" :options="tab.chartOptions" :constructor-type="'stockChart'"></highcharts>
              </div>
              <DeviceTable v-if="tab.tableParams !== null" :params="tab.tableParams" :values="values"></DeviceTable>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>

import Breadcrumbs from '../../components/Breadcrumbs.vue'
import DeviceTable from '../../components/devices/DeviceTable.vue'
import api from '../../api/api'
import moment from 'moment'
import device from '../../api/device'
import { Chart } from 'highcharts-vue'
import stockInit from 'highcharts/modules/stock'
import Highcharts from 'highcharts'
import '../../../node_modules/flatpickr/dist/themes/dark.css'
import '../../assets/css/js-datapicer.scss'
import graphConfigs from '../../components/graphConfigs'
import object from 'lodash/object'
import Param from '@/helpers/Param'

stockInit(Highcharts)

export default {
  name: 'DeviceView',
  components: {
    Breadcrumbs,
    DeviceTable,
    'highcharts': Chart
  },
  data () {
    return {
      isActive: false,
      breadcrumbsData: null,
      stationId: null,
      params: null,
      values: null,
      tabsConfig: null,
      currentTab: 0,
      componentKey: 0
    }
  },
  computed: {
    tabs () {
      const id = this.$route.params.id

      return this.tabsConfig.map((tab, idx) => {
        const params = tab.params.map(p => {
          return Param.normalizeDeviceKey(id, p.key)
        })
        const series = tab.params.map(p => {
          let data = this.values !== null ? this.values[ Param.normalizeDeviceKey(id, p.key) ] : []

          return {
            name: p.title,
            data: data
          }
        })
        const tableParams = tab.params.map(p => {
          return {
            title: p.title,
            name: p.key,
            key: Param.normalizeDeviceKey(id, p.key)
          }
        })

        return {
          id: idx,
          title: tab.title,
          params: params,
          chartOptions: object.merge(graphConfigs.data().chartOptions, {
            series: series,
            rangeSelector: {
              enabled: false
            },
            chart: {
              marginLeft: 30,
              marginRight: 30
            },
            yAxis: {
              labels: {
                style: {
                  color: '#ffffff'
                }
              },
              gridLineColor: '#595c5e'
            },
            xAxis: {
              labels: {
                style: {
                  color: '#ffffff'
                }
              }
            }
          }),
          tableParams: tableParams
        }
      })
    }
  },
  created () {
    let id = this.$route.params.id

    api.get('/devices/' + id)
      .then(r => {
        this.stationId = r.data.stationId
        this.$store.dispatch('station/findOne', this.stationId)

        this.breadcrumbsData = [
          {
            url: '/station-view/' + r.data.stationId,
            title: r.data.stationName
          },
          {
            url: '/device-list/' + r.data.stationId + '/' + r.data.deviceTypeId,
            title: r.data.deviceTypeName
          },
          {
            url: '#',
            title: r.data.name
          }
        ]

        this.fetchData(r.data.deviceTypeId)
          .then(r => {
            this.params = r.params
            this.tabsConfig = r.tabsConfig
            this.componentKey++

            let devices = {}
            devices[ id ] = this.params.map(p => p.key)

            this.$store.dispatch('common/toggleLoading', true)

            api.post('/station-data/' + this.stationId, {
              'devices': devices,
              'from': moment()
                .subtract(2, 'days')
                .format('YYYY-MM-DD HH:mm:ss')
            })
              .then(r => {
                this.values = r.data
                this.$store.dispatch('common/toggleLoading', false)
              })
          })
      })
  },
  methods: {
    clickTabs (tabName) {
      this.currentTab = tabName
    },
    toggleClass () {
      if (window.innerWidth <= 992) {
        this.isActive = !this.isActive
      }
    },
    async fetchData (typeId) {
      let result = {}

      try {
        const r = await device.types()
        const deviceType = r.data.find(deviceType => deviceType.id === typeId)
        result.params = deviceType.config.list.params
        result.tabsConfig = deviceType.config.tabs
      } catch (err) {
        throw new Error('Cant fetch params config')
      }

      return result
    }
  }
}
</script>
